export const normalizeLanguage = (language) => {
  const base = String(language || '').toLowerCase().split('-')[0];
  return ['en', 'ar'].includes(base) ? base : null;
};
